import UserManagement from './user-management';

export default UserManagement;
